module.exports = "data:image/gif;base64,R0lGODlhfwAgAKEDAP9lAP9mAP9nAP///yH+EUNyZWF0ZWQgd2l0aCBHSU1QACH5BAEKAAMALAAAAAB/ACAAAAL+nI+py+0Po5y02ouz3rzDAATi6JXmuYzqGqDum7FyR8K2Ja90ffdT3tqwfMRIjjN7jAASlVFkCDV4CCrj6BBYDUAV8wCchlPjQRc8dCQVZXPXyX0n3tC5nD7QpsU69tlNV7fytde3Fnf3B7jl11elkxYYtKfHA4d4uViXZ4m12LSHuRly6Yl2SQpndcgq8Fgo4vrkqLkJG1oba9qY2fYaufkRmlNZepireABQTCvH6wv4HCxpe0wdJOrr/LvLOkx9SpsrHCgtjrz63YxLhntsno3Nfb4dPy//bi5vP0fouNaJHTp48fC9M8gOXK1wkER8GadvH8RUmQoCxIPO0LVbFg0FQox4MJAsizXKkbyYzM45htBOBsu4D8jIggtZ0punpp4CiisHLlgWK4tDO0qCqhRUkQ8jPlKKgihyQeNSqFQ9dHxZNavVllq7atjlNezXpGLLmj2LNi2EAgA7"


//////////////////
// WEBPACK FOOTER
// ./src/front/assets/images/airlines/U2.gif
// module id = bjgQ
// module chunks = 9